// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SendScreenerLinkPopup-module__font-s-10___B9I4Z {
  font-size: 10px !important;
}

.SendScreenerLinkPopup-module__font-s-12___N2JZg {
  font-size: 12px !important;
}

.SendScreenerLinkPopup-module__font-s-13___VUOVW {
  font-size: 13px !important;
}

.SendScreenerLinkPopup-module__font-s-14___SkSJT {
  font-size: 14px !important;
}

.SendScreenerLinkPopup-module__font-s-15___y3mbq {
  font-size: 15px !important;
}

.SendScreenerLinkPopup-module__font-s-16___UZU7D {
  font-size: 16px !important;
}

.SendScreenerLinkPopup-module__font-s-18___ZHShR {
  font-size: 18px !important;
}

.SendScreenerLinkPopup-module__font-s-20___xC8H_ {
  font-size: 20px !important;
}

.SendScreenerLinkPopup-module__font-s-22___Q7j7a {
  font-size: 22px !important;
}

.SendScreenerLinkPopup-module__font-s-28___rLy42 {
  font-size: 28px !important;
}

.SendScreenerLinkPopup-module__font-w-400___IkRBt {
  font-weight: 400 !important;
}

.SendScreenerLinkPopup-module__font-w-500___kb7UN {
  font-weight: 500 !important;
}

.SendScreenerLinkPopup-module__font-w-600___yz4RC {
  font-weight: 600 !important;
}

.SendScreenerLinkPopup-module__font-w-700___jS1ky {
  font-weight: 700 !important;
}

.SendScreenerLinkPopup-module__p-5___dlEhj {
  padding: 5px !important;
}

.SendScreenerLinkPopup-module__p-12___Vd4n2 {
  padding: 12px !important;
}

.SendScreenerLinkPopup-module__p-16___GaQxc {
  padding: 16px !important;
}

.SendScreenerLinkPopup-module__p-30___eKJI7 {
  padding: 30px !important;
}

.SendScreenerLinkPopup-module__p-b-0___paEoV {
  padding-bottom: 0 !important;
}

.SendScreenerLinkPopup-module__p-b-5___ArFSA {
  padding-bottom: 5px !important;
}

.SendScreenerLinkPopup-module__p-b-10___do9kR {
  padding-bottom: 10px !important;
}

.SendScreenerLinkPopup-module__p-b-12___bWlNr {
  padding-bottom: 12px !important;
}

.SendScreenerLinkPopup-module__p-b-16___JIEF3 {
  padding-bottom: 16px !important;
}

.SendScreenerLinkPopup-module__p-b-18___EDCWB {
  padding-bottom: 18px !important;
}

.SendScreenerLinkPopup-module__p-b-20___CbkM8 {
  padding-bottom: 20px !important;
}

.SendScreenerLinkPopup-module__p-b-25___LGpg2 {
  padding-bottom: 25px !important;
}

.SendScreenerLinkPopup-module__p-b-30___TzQBQ {
  padding-bottom: 30px !important;
}

.SendScreenerLinkPopup-module__p-b-50___ufuyu {
  padding-bottom: 50px !important;
}

.SendScreenerLinkPopup-module__p-t-0___fVIBS {
  padding-top: 0 !important;
}

.SendScreenerLinkPopup-module__p-t-12___cd7FZ {
  padding-top: 12px !important;
}

.SendScreenerLinkPopup-module__p-t-16___OWMeZ {
  padding-top: 16px !important;
}

.SendScreenerLinkPopup-module__p-t-18___AuQFC {
  padding-top: 18px !important;
}

.SendScreenerLinkPopup-module__p-t-20___gMSuV {
  padding-top: 20px !important;
}

.SendScreenerLinkPopup-module__p-t-30___xqBds {
  padding-top: 30px !important;
}

.SendScreenerLinkPopup-module__p-t-40___vIwyr {
  padding-top: 40px !important;
}

.SendScreenerLinkPopup-module__p-t-50___NvNLd {
  padding-top: 50px !important;
}

.SendScreenerLinkPopup-module__p-l-20___kbvs3 {
  padding-left: 20px !important;
}

.SendScreenerLinkPopup-module__p-l-30___m8pMr {
  padding-left: 30px !important;
}

.SendScreenerLinkPopup-module__p-l-40___sd5W7 {
  padding-left: 40px !important;
}

.SendScreenerLinkPopup-module__p-r-16___Y1Iok {
  padding-right: 16px !important;
}

.SendScreenerLinkPopup-module__p-r-20___pzZmY {
  padding-right: 20px !important;
}

.SendScreenerLinkPopup-module__p-r-30___NmU8U {
  padding-right: 30px !important;
}

.SendScreenerLinkPopup-module__p-r-50___FS54Y {
  padding-right: 50px !important;
}

.SendScreenerLinkPopup-module__p-r-60___TVDv3 {
  padding-right: 60px !important;
}

.SendScreenerLinkPopup-module__m-b-1___qsTPY {
  margin-bottom: 1px !important;
}

.SendScreenerLinkPopup-module__m-b-2___nGWDU {
  margin-bottom: 2px !important;
}

.SendScreenerLinkPopup-module__m-b-6___iLkhV {
  margin-bottom: 6px !important;
}

.SendScreenerLinkPopup-module__m-b-8___dKpzP {
  margin-bottom: 8px !important;
}

.SendScreenerLinkPopup-module__m-b-10____F0g4 {
  margin-bottom: 10px !important;
}

.SendScreenerLinkPopup-module__m-b-14___tgMSA {
  margin-bottom: 14px !important;
}

.SendScreenerLinkPopup-module__m-b-16___cha6k {
  margin-bottom: 16px !important;
}

.SendScreenerLinkPopup-module__m-b-20___NvcxE {
  margin-bottom: 20px !important;
}

.SendScreenerLinkPopup-module__m-b-22___Uko0q {
  margin-bottom: 22px !important;
}

.SendScreenerLinkPopup-module__m-b-24___aR6C6 {
  margin-bottom: 24px !important;
}

.SendScreenerLinkPopup-module__m-b-30___w8sOa {
  margin-bottom: 30px !important;
}

.SendScreenerLinkPopup-module__m-b-32___q1Ioi {
  margin-bottom: 32px !important;
}

.SendScreenerLinkPopup-module__m-b-40___rjaZr {
  margin-bottom: 40px !important;
}

.SendScreenerLinkPopup-module__m-t-2___cE_nm {
  margin-top: 2px !important;
}

.SendScreenerLinkPopup-module__m-t-3___BGxiK {
  margin-top: 3px !important;
}

.SendScreenerLinkPopup-module__m-t-4___TEH5_ {
  margin-top: 4px !important;
}

.SendScreenerLinkPopup-module__m-t-5___Vzvs1 {
  margin-top: 5px !important;
}

.SendScreenerLinkPopup-module__m-t-8___vuTvt {
  margin-top: 8px !important;
}

.SendScreenerLinkPopup-module__m-t-10___Bg2T6 {
  margin-top: 10px !important;
}

.SendScreenerLinkPopup-module__m-t-15___PQdmG {
  margin-top: 15px !important;
}

.SendScreenerLinkPopup-module__m-t-16___GD7ce {
  margin-top: 16px !important;
}

.SendScreenerLinkPopup-module__m-t-20___JPbj0 {
  margin-top: 20px !important;
}

.SendScreenerLinkPopup-module__m-t-22___VE5xN {
  margin-top: 22px !important;
}

.SendScreenerLinkPopup-module__m-t-30___pwxii {
  margin-top: 30px !important;
}

.SendScreenerLinkPopup-module__m-t-32___aVY6g {
  margin-top: 32px !important;
}

.SendScreenerLinkPopup-module__m-l-auto___F86q4 {
  margin-left: auto !important;
}

.SendScreenerLinkPopup-module__m-l-4___cdosm {
  margin-left: 4px !important;
}

.SendScreenerLinkPopup-module__m-l-5___EaUa0 {
  margin-left: 5px !important;
}

.SendScreenerLinkPopup-module__m-l-6___C0EsG {
  margin-left: 6px !important;
}

.SendScreenerLinkPopup-module__m-l-8___nGoap {
  margin-left: 8px !important;
}

.SendScreenerLinkPopup-module__m-l-10___PJ6hJ {
  margin-left: 10px !important;
}

.SendScreenerLinkPopup-module__m-l-16___mqdXV {
  margin-left: 16px !important;
}

.SendScreenerLinkPopup-module__m-l-20___guDCJ {
  margin-left: 20px !important;
}

.SendScreenerLinkPopup-module__m-l-24___Idw33 {
  margin-left: 24px !important;
}

.SendScreenerLinkPopup-module__m-l-30___P81Qy {
  margin-left: 30px !important;
}

.SendScreenerLinkPopup-module__m-l-35___Y2TZ0 {
  margin-left: 35px !important;
}

.SendScreenerLinkPopup-module__m-l-40___w1dBx {
  margin-left: 40px !important;
}

.SendScreenerLinkPopup-module__m-r-8___Scywg {
  margin-right: 8px !important;
}

.SendScreenerLinkPopup-module__m-r-10___Yb3xO {
  margin-right: 10px !important;
}

.SendScreenerLinkPopup-module__m-r-16___j3jKF {
  margin-right: 16px !important;
}

.SendScreenerLinkPopup-module__m-r-20___fk6oh {
  margin-right: 20px !important;
}

.SendScreenerLinkPopup-module__m-r-24___vlf2B {
  margin-right: 24px !important;
}

.SendScreenerLinkPopup-module__m-r-30____EaLR {
  margin-right: 30px !important;
}

.SendScreenerLinkPopup-module__m-r-40___rkY9t {
  margin-right: 40px !important;
}

.SendScreenerLinkPopup-module__border-r-3___CkiaP {
  border-radius: 3px !important;
}

.SendScreenerLinkPopup-module__border-r-4___NGrTy {
  border-radius: 4px !important;
}

.SendScreenerLinkPopup-module__border-r-6___BbHmE {
  border-radius: 6px !important;
}

.SendScreenerLinkPopup-module__border-r-10___aT3Rc {
  border-radius: 10px !important;
}

.SendScreenerLinkPopup-module__border-r-12___YcyNW {
  border-radius: 12px !important;
}

.SendScreenerLinkPopup-module__border-r-16___o6rGs {
  border-radius: 16px !important;
}

.SendScreenerLinkPopup-module__border-r-50___k3FAj {
  border-radius: 50% !important;
}

.SendScreenerLinkPopup-module__primary-border___JYR3r {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.SendScreenerLinkPopup-module__primary-border-b___xn4Bx {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.SendScreenerLinkPopup-module__primary-border-t___Dd1a0 {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.SendScreenerLinkPopup-module__primary-border-l___WNnUF {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.SendScreenerLinkPopup-module__primary-border-r___tMlTy {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.SendScreenerLinkPopup-module__secondary-border___c92sL {
  border: 1px solid #637768;
}

.SendScreenerLinkPopup-module__secondary-border-b___FINBH {
  border-bottom: 1px solid #637768;
}

.SendScreenerLinkPopup-module__secondary-border-t___BVK1B {
  border-top: 1px solid #637768;
}

.SendScreenerLinkPopup-module__secondary-border-l___ApsOG {
  border-left: 1px solid #637768;
}

.SendScreenerLinkPopup-module__secondary-border-r___p9iVF {
  border-right: 1px solid #637768;
}

.SendScreenerLinkPopup-module__gap-0___P8OHF {
  gap: 0 !important;
}

.SendScreenerLinkPopup-module__gap-2___sjE_K {
  gap: 2px !important;
}

.SendScreenerLinkPopup-module__gap-4___TKSwF {
  gap: 4px !important;
}

.SendScreenerLinkPopup-module__gap-5___Y65Ql {
  gap: 5px !important;
}

.SendScreenerLinkPopup-module__gap-6___Mg5D6 {
  gap: 6px !important;
}

.SendScreenerLinkPopup-module__gap-8___Bx5dV {
  gap: 8px !important;
}

.SendScreenerLinkPopup-module__gap-10___IWaYd {
  gap: 10px !important;
}

.SendScreenerLinkPopup-module__gap-12___Car7P {
  gap: 12px !important;
}

.SendScreenerLinkPopup-module__gap-14___DN6oG {
  gap: 14px !important;
}

.SendScreenerLinkPopup-module__gap-16___HkHUn {
  gap: 16px !important;
}

.SendScreenerLinkPopup-module__gap-18____FHjX {
  gap: 18px !important;
}

.SendScreenerLinkPopup-module__gap-20___vypNz {
  gap: 20px !important;
}

.SendScreenerLinkPopup-module__gap-24___hfUx8 {
  gap: 24px !important;
}

.SendScreenerLinkPopup-module__gap-26___Hil6g {
  gap: 26px !important;
}

.SendScreenerLinkPopup-module__gap-30___PhxDs {
  gap: 30px !important;
}

.SendScreenerLinkPopup-module__gap-32___raqpH {
  gap: 32px !important;
}

.SendScreenerLinkPopup-module__gap-40___x1dnx {
  gap: 40px !important;
}

.SendScreenerLinkPopup-module__gap-50___BbRur {
  gap: 50px !important;
}

.SendScreenerLinkPopup-module__flex-1___xnBkg {
  flex: 1;
}

.SendScreenerLinkPopup-module__flex-none___ZNxvs {
  flex: none !important;
}

.SendScreenerLinkPopup-module__flex-column___N95KV {
  display: flex;
  flex-direction: column !important;
}

.SendScreenerLinkPopup-module__flex-row___t2Nbo {
  display: flex;
  flex-direction: row !important;
}

.SendScreenerLinkPopup-module__vertically-centered___FyC4c {
  display: flex;
  align-items: center !important;
}

.SendScreenerLinkPopup-module__horizontally-centered___xdIEn {
  display: flex;
  justify-content: center !important;
}

.SendScreenerLinkPopup-module__horizontally-end___xYjkR {
  display: flex;
  justify-content: end !important;
}

.SendScreenerLinkPopup-module__vertically-start___Xo02P {
  display: flex;
  align-items: start !important;
}

.SendScreenerLinkPopup-module__space-between___GF4zq {
  display: flex;
  justify-content: space-between !important;
}

.SendScreenerLinkPopup-module__flex-wrap___PiX2Q {
  flex-wrap: wrap !important;
}

.SendScreenerLinkPopup-module__height-100___s24to {
  height: 100%;
}

.SendScreenerLinkPopup-module__width-50___r52Ll {
  width: 50% !important;
}

.SendScreenerLinkPopup-module__width-100___6sG_O {
  width: 100%;
}

.SendScreenerLinkPopup-module__cursor-pointer___K53He {
  cursor: pointer;
}

.SendScreenerLinkPopup-module__cursor-not-allowed___Ezsqk {
  cursor: not-allowed !important;
}

.SendScreenerLinkPopup-module__absolute-centered___ZHYZQ {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.SendScreenerLinkPopup-module__absolute___ay284 {
  position: absolute;
}

.SendScreenerLinkPopup-module__relative___UqKxQ {
  position: relative;
}

.SendScreenerLinkPopup-module__fixed____NJCm {
  position: fixed;
}

.SendScreenerLinkPopup-module__visible___GArjp {
  opacity: 1;
}

.SendScreenerLinkPopup-module__invisible___E0EGm {
  opacity: 0;
}

.SendScreenerLinkPopup-module__col-90___HTSuK {
  width: 90% !important;
}

.SendScreenerLinkPopup-module__col-auto___F0g2b {
  width: auto !important;
}

.SendScreenerLinkPopup-module__medical-tabs___kZgUH {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.SendScreenerLinkPopup-module__medical-table-new___qCUlQ {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.SendScreenerLinkPopup-module__medical-table-new___qCUlQ:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.SendScreenerLinkPopup-module__medical-table-new___qCUlQ::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.SendScreenerLinkPopup-module__medical-table-new___qCUlQ::-webkit-scrollbar-track {
  display: none;
}
.SendScreenerLinkPopup-module__medical-table-new___qCUlQ.SendScreenerLinkPopup-module__no-pagination___m1bp7 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.SendScreenerLinkPopup-module__medical-table-new___qCUlQ.SendScreenerLinkPopup-module__no-pagination___m1bp7:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.SendScreenerLinkPopup-module__medical-table-new___qCUlQ.SendScreenerLinkPopup-module__no-pagination___m1bp7::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.SendScreenerLinkPopup-module__medical-table-new___qCUlQ.SendScreenerLinkPopup-module__no-pagination___m1bp7::-webkit-scrollbar-track {
  display: none;
}

.SendScreenerLinkPopup-module__medical-table-empty___YjQtb {
  padding: 14px 40px !important;
}

.SendScreenerLinkPopup-module__icon-btn___Kt_lk {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.SendScreenerLinkPopup-module__search-icon___M2lVw {
  width: 24px;
  height: 24px;
  align-self: center;
}

.SendScreenerLinkPopup-module__disable-select___C9sQg {
  user-select: none;
}

.SendScreenerLinkPopup-module__break-word___U5o9l {
  word-break: break-word;
}

.SendScreenerLinkPopup-module__popup-clear-btn___KRQ8P {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.SendScreenerLinkPopup-module__scroll-m-b-20___VfV6q {
  scroll-margin-bottom: 20px;
}

.SendScreenerLinkPopup-module__content___PWXD5 {
  padding: 25px 30px;
  color: #375844;
}

.SendScreenerLinkPopup-module__buttonsContainer___RgCwp {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
  justify-content: end;
  padding: 30px;
  display: flex;
  gap: 16px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/popups/SendScreenerLinkPopup/SendScreenerLinkPopup.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,kBAAA;EACA,cAAA;AA8pBF;;AA3pBA;EACE,2CAAA;EACA,oBAAA;EACA,aAAA;EACA,aAAA;EACA,SAAA;AA8pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.content {\n  padding: 25px 30px;\n  color: get-color(greenNew, dark);\n}\n\n.buttonsContainer {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n  justify-content: end;\n  padding: 30px;\n  display: flex;\n  gap: 16px;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `SendScreenerLinkPopup-module__font-s-10___B9I4Z`,
	"fontS12": `SendScreenerLinkPopup-module__font-s-12___N2JZg`,
	"fontS13": `SendScreenerLinkPopup-module__font-s-13___VUOVW`,
	"fontS14": `SendScreenerLinkPopup-module__font-s-14___SkSJT`,
	"fontS15": `SendScreenerLinkPopup-module__font-s-15___y3mbq`,
	"fontS16": `SendScreenerLinkPopup-module__font-s-16___UZU7D`,
	"fontS18": `SendScreenerLinkPopup-module__font-s-18___ZHShR`,
	"fontS20": `SendScreenerLinkPopup-module__font-s-20___xC8H_`,
	"fontS22": `SendScreenerLinkPopup-module__font-s-22___Q7j7a`,
	"fontS28": `SendScreenerLinkPopup-module__font-s-28___rLy42`,
	"fontW400": `SendScreenerLinkPopup-module__font-w-400___IkRBt`,
	"fontW500": `SendScreenerLinkPopup-module__font-w-500___kb7UN`,
	"fontW600": `SendScreenerLinkPopup-module__font-w-600___yz4RC`,
	"fontW700": `SendScreenerLinkPopup-module__font-w-700___jS1ky`,
	"p5": `SendScreenerLinkPopup-module__p-5___dlEhj`,
	"p12": `SendScreenerLinkPopup-module__p-12___Vd4n2`,
	"p16": `SendScreenerLinkPopup-module__p-16___GaQxc`,
	"p30": `SendScreenerLinkPopup-module__p-30___eKJI7`,
	"pB0": `SendScreenerLinkPopup-module__p-b-0___paEoV`,
	"pB5": `SendScreenerLinkPopup-module__p-b-5___ArFSA`,
	"pB10": `SendScreenerLinkPopup-module__p-b-10___do9kR`,
	"pB12": `SendScreenerLinkPopup-module__p-b-12___bWlNr`,
	"pB16": `SendScreenerLinkPopup-module__p-b-16___JIEF3`,
	"pB18": `SendScreenerLinkPopup-module__p-b-18___EDCWB`,
	"pB20": `SendScreenerLinkPopup-module__p-b-20___CbkM8`,
	"pB25": `SendScreenerLinkPopup-module__p-b-25___LGpg2`,
	"pB30": `SendScreenerLinkPopup-module__p-b-30___TzQBQ`,
	"pB50": `SendScreenerLinkPopup-module__p-b-50___ufuyu`,
	"pT0": `SendScreenerLinkPopup-module__p-t-0___fVIBS`,
	"pT12": `SendScreenerLinkPopup-module__p-t-12___cd7FZ`,
	"pT16": `SendScreenerLinkPopup-module__p-t-16___OWMeZ`,
	"pT18": `SendScreenerLinkPopup-module__p-t-18___AuQFC`,
	"pT20": `SendScreenerLinkPopup-module__p-t-20___gMSuV`,
	"pT30": `SendScreenerLinkPopup-module__p-t-30___xqBds`,
	"pT40": `SendScreenerLinkPopup-module__p-t-40___vIwyr`,
	"pT50": `SendScreenerLinkPopup-module__p-t-50___NvNLd`,
	"pL20": `SendScreenerLinkPopup-module__p-l-20___kbvs3`,
	"pL30": `SendScreenerLinkPopup-module__p-l-30___m8pMr`,
	"pL40": `SendScreenerLinkPopup-module__p-l-40___sd5W7`,
	"pR16": `SendScreenerLinkPopup-module__p-r-16___Y1Iok`,
	"pR20": `SendScreenerLinkPopup-module__p-r-20___pzZmY`,
	"pR30": `SendScreenerLinkPopup-module__p-r-30___NmU8U`,
	"pR50": `SendScreenerLinkPopup-module__p-r-50___FS54Y`,
	"pR60": `SendScreenerLinkPopup-module__p-r-60___TVDv3`,
	"mB1": `SendScreenerLinkPopup-module__m-b-1___qsTPY`,
	"mB2": `SendScreenerLinkPopup-module__m-b-2___nGWDU`,
	"mB6": `SendScreenerLinkPopup-module__m-b-6___iLkhV`,
	"mB8": `SendScreenerLinkPopup-module__m-b-8___dKpzP`,
	"mB10": `SendScreenerLinkPopup-module__m-b-10____F0g4`,
	"mB14": `SendScreenerLinkPopup-module__m-b-14___tgMSA`,
	"mB16": `SendScreenerLinkPopup-module__m-b-16___cha6k`,
	"mB20": `SendScreenerLinkPopup-module__m-b-20___NvcxE`,
	"mB22": `SendScreenerLinkPopup-module__m-b-22___Uko0q`,
	"mB24": `SendScreenerLinkPopup-module__m-b-24___aR6C6`,
	"mB30": `SendScreenerLinkPopup-module__m-b-30___w8sOa`,
	"mB32": `SendScreenerLinkPopup-module__m-b-32___q1Ioi`,
	"mB40": `SendScreenerLinkPopup-module__m-b-40___rjaZr`,
	"mT2": `SendScreenerLinkPopup-module__m-t-2___cE_nm`,
	"mT3": `SendScreenerLinkPopup-module__m-t-3___BGxiK`,
	"mT4": `SendScreenerLinkPopup-module__m-t-4___TEH5_`,
	"mT5": `SendScreenerLinkPopup-module__m-t-5___Vzvs1`,
	"mT8": `SendScreenerLinkPopup-module__m-t-8___vuTvt`,
	"mT10": `SendScreenerLinkPopup-module__m-t-10___Bg2T6`,
	"mT15": `SendScreenerLinkPopup-module__m-t-15___PQdmG`,
	"mT16": `SendScreenerLinkPopup-module__m-t-16___GD7ce`,
	"mT20": `SendScreenerLinkPopup-module__m-t-20___JPbj0`,
	"mT22": `SendScreenerLinkPopup-module__m-t-22___VE5xN`,
	"mT30": `SendScreenerLinkPopup-module__m-t-30___pwxii`,
	"mT32": `SendScreenerLinkPopup-module__m-t-32___aVY6g`,
	"mLAuto": `SendScreenerLinkPopup-module__m-l-auto___F86q4`,
	"mL4": `SendScreenerLinkPopup-module__m-l-4___cdosm`,
	"mL5": `SendScreenerLinkPopup-module__m-l-5___EaUa0`,
	"mL6": `SendScreenerLinkPopup-module__m-l-6___C0EsG`,
	"mL8": `SendScreenerLinkPopup-module__m-l-8___nGoap`,
	"mL10": `SendScreenerLinkPopup-module__m-l-10___PJ6hJ`,
	"mL16": `SendScreenerLinkPopup-module__m-l-16___mqdXV`,
	"mL20": `SendScreenerLinkPopup-module__m-l-20___guDCJ`,
	"mL24": `SendScreenerLinkPopup-module__m-l-24___Idw33`,
	"mL30": `SendScreenerLinkPopup-module__m-l-30___P81Qy`,
	"mL35": `SendScreenerLinkPopup-module__m-l-35___Y2TZ0`,
	"mL40": `SendScreenerLinkPopup-module__m-l-40___w1dBx`,
	"mR8": `SendScreenerLinkPopup-module__m-r-8___Scywg`,
	"mR10": `SendScreenerLinkPopup-module__m-r-10___Yb3xO`,
	"mR16": `SendScreenerLinkPopup-module__m-r-16___j3jKF`,
	"mR20": `SendScreenerLinkPopup-module__m-r-20___fk6oh`,
	"mR24": `SendScreenerLinkPopup-module__m-r-24___vlf2B`,
	"mR30": `SendScreenerLinkPopup-module__m-r-30____EaLR`,
	"mR40": `SendScreenerLinkPopup-module__m-r-40___rkY9t`,
	"borderR3": `SendScreenerLinkPopup-module__border-r-3___CkiaP`,
	"borderR4": `SendScreenerLinkPopup-module__border-r-4___NGrTy`,
	"borderR6": `SendScreenerLinkPopup-module__border-r-6___BbHmE`,
	"borderR10": `SendScreenerLinkPopup-module__border-r-10___aT3Rc`,
	"borderR12": `SendScreenerLinkPopup-module__border-r-12___YcyNW`,
	"borderR16": `SendScreenerLinkPopup-module__border-r-16___o6rGs`,
	"borderR50": `SendScreenerLinkPopup-module__border-r-50___k3FAj`,
	"primaryBorder": `SendScreenerLinkPopup-module__primary-border___JYR3r`,
	"primaryBorderB": `SendScreenerLinkPopup-module__primary-border-b___xn4Bx`,
	"primaryBorderT": `SendScreenerLinkPopup-module__primary-border-t___Dd1a0`,
	"primaryBorderL": `SendScreenerLinkPopup-module__primary-border-l___WNnUF`,
	"primaryBorderR": `SendScreenerLinkPopup-module__primary-border-r___tMlTy`,
	"secondaryBorder": `SendScreenerLinkPopup-module__secondary-border___c92sL`,
	"secondaryBorderB": `SendScreenerLinkPopup-module__secondary-border-b___FINBH`,
	"secondaryBorderT": `SendScreenerLinkPopup-module__secondary-border-t___BVK1B`,
	"secondaryBorderL": `SendScreenerLinkPopup-module__secondary-border-l___ApsOG`,
	"secondaryBorderR": `SendScreenerLinkPopup-module__secondary-border-r___p9iVF`,
	"gap0": `SendScreenerLinkPopup-module__gap-0___P8OHF`,
	"gap2": `SendScreenerLinkPopup-module__gap-2___sjE_K`,
	"gap4": `SendScreenerLinkPopup-module__gap-4___TKSwF`,
	"gap5": `SendScreenerLinkPopup-module__gap-5___Y65Ql`,
	"gap6": `SendScreenerLinkPopup-module__gap-6___Mg5D6`,
	"gap8": `SendScreenerLinkPopup-module__gap-8___Bx5dV`,
	"gap10": `SendScreenerLinkPopup-module__gap-10___IWaYd`,
	"gap12": `SendScreenerLinkPopup-module__gap-12___Car7P`,
	"gap14": `SendScreenerLinkPopup-module__gap-14___DN6oG`,
	"gap16": `SendScreenerLinkPopup-module__gap-16___HkHUn`,
	"gap18": `SendScreenerLinkPopup-module__gap-18____FHjX`,
	"gap20": `SendScreenerLinkPopup-module__gap-20___vypNz`,
	"gap24": `SendScreenerLinkPopup-module__gap-24___hfUx8`,
	"gap26": `SendScreenerLinkPopup-module__gap-26___Hil6g`,
	"gap30": `SendScreenerLinkPopup-module__gap-30___PhxDs`,
	"gap32": `SendScreenerLinkPopup-module__gap-32___raqpH`,
	"gap40": `SendScreenerLinkPopup-module__gap-40___x1dnx`,
	"gap50": `SendScreenerLinkPopup-module__gap-50___BbRur`,
	"flex1": `SendScreenerLinkPopup-module__flex-1___xnBkg`,
	"flexNone": `SendScreenerLinkPopup-module__flex-none___ZNxvs`,
	"flexColumn": `SendScreenerLinkPopup-module__flex-column___N95KV`,
	"flexRow": `SendScreenerLinkPopup-module__flex-row___t2Nbo`,
	"verticallyCentered": `SendScreenerLinkPopup-module__vertically-centered___FyC4c`,
	"horizontallyCentered": `SendScreenerLinkPopup-module__horizontally-centered___xdIEn`,
	"horizontallyEnd": `SendScreenerLinkPopup-module__horizontally-end___xYjkR`,
	"verticallyStart": `SendScreenerLinkPopup-module__vertically-start___Xo02P`,
	"spaceBetween": `SendScreenerLinkPopup-module__space-between___GF4zq`,
	"flexWrap": `SendScreenerLinkPopup-module__flex-wrap___PiX2Q`,
	"height100": `SendScreenerLinkPopup-module__height-100___s24to`,
	"width50": `SendScreenerLinkPopup-module__width-50___r52Ll`,
	"width100": `SendScreenerLinkPopup-module__width-100___6sG_O`,
	"cursorPointer": `SendScreenerLinkPopup-module__cursor-pointer___K53He`,
	"cursorNotAllowed": `SendScreenerLinkPopup-module__cursor-not-allowed___Ezsqk`,
	"absoluteCentered": `SendScreenerLinkPopup-module__absolute-centered___ZHYZQ`,
	"absolute": `SendScreenerLinkPopup-module__absolute___ay284`,
	"relative": `SendScreenerLinkPopup-module__relative___UqKxQ`,
	"fixed": `SendScreenerLinkPopup-module__fixed____NJCm`,
	"visible": `SendScreenerLinkPopup-module__visible___GArjp`,
	"invisible": `SendScreenerLinkPopup-module__invisible___E0EGm`,
	"col90": `SendScreenerLinkPopup-module__col-90___HTSuK`,
	"colAuto": `SendScreenerLinkPopup-module__col-auto___F0g2b`,
	"medicalTabs": `SendScreenerLinkPopup-module__medical-tabs___kZgUH`,
	"medicalTableNew": `SendScreenerLinkPopup-module__medical-table-new___qCUlQ`,
	"noPagination": `SendScreenerLinkPopup-module__no-pagination___m1bp7`,
	"medicalTableEmpty": `SendScreenerLinkPopup-module__medical-table-empty___YjQtb`,
	"iconBtn": `SendScreenerLinkPopup-module__icon-btn___Kt_lk`,
	"searchIcon": `SendScreenerLinkPopup-module__search-icon___M2lVw`,
	"disableSelect": `SendScreenerLinkPopup-module__disable-select___C9sQg`,
	"breakWord": `SendScreenerLinkPopup-module__break-word___U5o9l`,
	"popupClearBtn": `SendScreenerLinkPopup-module__popup-clear-btn___KRQ8P`,
	"scrollMB20": `SendScreenerLinkPopup-module__scroll-m-b-20___VfV6q`,
	"content": `SendScreenerLinkPopup-module__content___PWXD5`,
	"buttonsContainer": `SendScreenerLinkPopup-module__buttonsContainer___RgCwp`
};
module.exports = ___CSS_LOADER_EXPORT___;
